module.exports = "<md-calendar sb-highlight-days md-mode=\"day\"\n\t\tng-if=\"vm.endDate && vm.beginDate && vm.items\"\n\t\tng-model=\"vm.selectedDate\" md-max-date=\"vm.endDate\" md-min-date=\"vm.beginDate\"></md-calendar>";


//////////////////
// WEBPACK FOOTER
// ./src/sharebase/components/calendarHeatMap/calendarHeatMap.template.html
// module id = 1065
// module chunks = 0